import axios from '../axios'

export default class RebatesService {
  getCustomers(body) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/rebates/customers'
        var response = await axios.post(path, body)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }

  batchUpdate(body) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/rebates/batchUpdate'
        var response = await axios.put(path, body)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
}
